<template>
  <div class="gs-app gs-sales-tax-page">
    <div class="gs-sales-tax-page__content">
      <v-wait for="dashboard">
        <div class="gs-sales-tax-page__state">
          {{ $t('frontend_sales_tax_coming_soon') }}
        </div>
      </v-wait>
    </div>
  </div>
</template>

<script>
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: 'Sales Tax' };
  },
};
</script>

<style scoped>
.gs-sales-tax-page {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gs-sales-tax-page__content {
  max-width: 960px;
  margin: 0 auto;
}

.gs-sales-tax-page__state {
  padding: 40px 24px;
  text-align: center;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

@media (max-width: 640px) {
  .gs-sales-tax-page {
    padding: 16px;
  }
}
</style>
